import Loadable from 'components/Loadable';
import { REDEEM_PATH, SURVEY_EXECUTE_HASHCODE, SURVEY_LIST_PATH } from 'constant/path';
import { lazy } from 'react';

const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/login/index')));
const AuthLogout = Loadable(lazy(() => import('views/authentication/AuthLogOutRedirectCallback')));
const Redeem = Loadable(lazy(() => import('views/pages/authentication/RedeemToken')));

const AuthLoginRedirectCallback = Loadable(
  lazy(() => import('views/authentication/AuthLoginRedirectCallback'))
);
const PreviewSurveyDevice = Loadable(
  lazy(() => import('views/pages/surveyList/previewSurveyDevice'))
);
const OnlyAppBarLayout = Loadable(lazy(() => import('layout/OnlyAppBarLayout')));
const AuthenticationRoutes = {
  path: '/',
  children: [
    {
      path: '/login',
      element: <AuthLogin />,
    },
    {
      path: '/logout',
      element: <AuthLogout />,
    },
    {
      path: '/assets/signin-callback.html',
      element: <AuthLoginRedirectCallback />,
    },
    {
      path: SURVEY_LIST_PATH,
      element: <OnlyAppBarLayout />,
      children: [
        {
          path: SURVEY_EXECUTE_HASHCODE,
          element: <PreviewSurveyDevice />,
        },
      ],
    },
    {
      path: REDEEM_PATH,
      element: <Redeem />,
    },
  ],
};

export default AuthenticationRoutes;
